import FamiliesList from '@/pages/FamiliesList.vue'
import ROUTE_NAMES from '@/constants/routeNames'

export default {
  path: '/lista-rodzin/:bubbleId',
  props: true,
  name: ROUTE_NAMES.FAMILIES_LIST,
  component: FamiliesList,
  meta: {
    title: 'Wybór Rodziny - lista Rodzin - Szlachetna Paczka',
    metaTags: [
      {
        name: 'robots',
        content: 'noindex, follow'
      }
    ]
  }
}
